import React from "react";
import ListDepartments from "../../../containers/Settings/Department/index";
const SettingDepartment = () => {
  return <ListDepartments />;
};
export default SettingDepartment;
